import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { InputHTMLAttributes, onMounted, ref, watch, inject } from "vue";
import { setValue, init, reInit } from "./litepicker";
import LitepickerJs from "litepicker";
import { FormInput } from "../../base-components/Form";
import { ILPConfiguration } from "litepicker/dist/types/interfaces";

export interface LitepickerElement extends HTMLInputElement {
  litePickerInstance: LitepickerJs;
}

export interface LitepickerEmit {
  (e: "update:modelValue", value: string): void;
}

export interface LitepickerProps extends InputHTMLAttributes {
  options: {
    format?: string | undefined;
  } & LitepickerConfig;
  modelValue: string;
  refKey?: string;
}

export type ProvideLitepicker = (el: LitepickerElement) => void;


// @ts-ignore
type LitepickerConfig = Partial<ILPConfiguration>;

export default /*#__PURE__*/_defineComponent({
  __name: 'Litepicker',
  props: {
    options: null,
    modelValue: null,
    refKey: null
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit }: { emit: ({
  (e: "update:modelValue", value: string): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  options: {
    format?: string | undefined;
  } & LitepickerConfig;
  modelValue: string;
  refKey?: string;
}



const litepickerRef = ref<LitepickerElement>();

const tempValue = ref(props.modelValue);



const vLitepickerDirective = {
  mounted(el: LitepickerElement) {
    setValue(props, emit);
    if (el !== null) {
      init(el, props, emit);
    }
  },
  updated(el: LitepickerElement) {
    if (tempValue.value !== props.modelValue && el !== null) {
      reInit(el, props, emit);
    }
  },
};

watch(props, () => {
  tempValue.value = props.modelValue;
});

const bindInstance = (el: LitepickerElement) => {
  if (props.refKey) {
    const bind = inject<ProvideLitepicker>(`bind[${props.refKey}]`);
    if (bind) {
      bind(el);
    }
  }
};

onMounted(() => {
  if (litepickerRef.value) {
    bindInstance(litepickerRef.value);
  }
});

return (_ctx: any,_cache: any) => {
  return _withDirectives((_openBlock(), _createBlock(_unref(FormInput), {
    ref_key: "litepickerRef",
    ref: litepickerRef,
    type: "text",
    value: props.modelValue,
    onChange: _cache[0] || (_cache[0] = (event) => {
      emit('update:modelValue', (event.target as HTMLSelectElement).value);
    })
  }, null, 8, ["value"])), [
    [vLitepickerDirective]
  ])
}
}

})